import { DeleteOutlined, FileWordOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Tooltip } from 'antd';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useDeleteArticleContentMediaMutation } from 'services';
import { fetchError } from 'slices/commonSlice';
import { openNotification } from 'utils';

const UploadedFile = ({ content, id, offerID, style, fontStyle, extra = false, disableDelete = false }) => {
  const [deleteArticleContentMedia] = useDeleteArticleContentMediaMutation();
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  // bağlanmış olan bir maddeyi silmek için kullanılır
  const handleDelete = async (e) => {
    // draggable alanda sadece butonun calismasini saglar
    e.stopPropagation();
    const { error } = await deleteArticleContentMedia({
      offerID,
      mediaID: id,
    });
    if (error) {
      return dispatch(
        fetchError(
          formatMessage(
            {
              id: 'article.form.fetchError',
            },
            { error: error.status }
          )
        )
      );
    }
    openNotification({
      message: formatMessage({
        id: 'appModule.actionSuccessfully',
      }),
    });
  };

  return (
    <div
      style={{
        ...style,
        fontSize: 24,
        padding: '0 16px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        backgroundColor: '#fafafa',
      }}
    >
      <div className="gx-d-flex gx-pt-3 gx-pb-3 gx-align-items-center gx-fit-text ">
        <FileWordOutlined />
        <span
          className="gx-ml-4"
          style={{ ...fontStyle, fontSize: 16 }}
        >
          {content}
        </span>
      </div>
      {extra ? (
        extra
      ) : (
        <Popconfirm
          placement="leftBottom"
          title="Silmek İstediğinizden Emin misiniz?"
          okText="Evet"
          onConfirm={handleDelete}
          disabled={disableDelete}
          onCancel={(e) => e.stopPropagation()}
        >
          <Tooltip title={disableDelete ? 'Sadece yeni eklenen dosyalar silinebilir. Dosyanızı değiştirmek için yeniden yükleme yapabilirsiniz.' : ''}>
            <Button
              icon={<DeleteOutlined />}
              type="text"
              onClick={(e) => e.stopPropagation()}
              disabled={disableDelete}
            />
          </Tooltip>
        </Popconfirm>
      )}
    </div>
  );
};

export default UploadedFile;
